module.exports = __webpack_public_path__ + "public/images/blob_banner_bg.e272cccf5231a9cb40c07eadd9df2952.png";